const e = "styles-module__segmentedControl___kSCW-", s = "styles-module__segments___6yXJZ", t = "styles-module__slidingBackground___tTLcn", n = "styles-module__segment___WVz4E", _ = "styles-module__active___VEhjz", o = {
  segmentedControl: e,
  segments: s,
  slidingBackground: t,
  segment: n,
  active: _
};
export {
  _ as active,
  o as default,
  n as segment,
  e as segmentedControl,
  s as segments,
  t as slidingBackground
};
